module.exports = __webpack_public_path__ + "img/1083737796.9d71fc03.jpg";